export function removeUnmanagedMetaTags(selectors: string[]) {
    if (typeof document === "undefined") return;
    selectors.forEach((selector) => {
        document.head.querySelectorAll(`${selector}:not([data-rh])`).forEach((el) => el.remove());
    });
}
